import React from 'react';
import Carousel from 'react-material-ui-carousel'
import {Paper, makeStyles} from '@material-ui/core'
import Plano from './Plano'

function Item({plano})
{   
  const classes = useStyles();
  return ( 
    <Paper  className={classes.root}>
      <Plano data={plano}/>
    </Paper>
  )
}

export default function CarouselPlano({planos})
{
  return (
    <Carousel>
      {
        planos?.map( (plano, i) => <Item key={i} plano={plano} /> )
      }
    </Carousel>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    justifyContent: "center",
    alignplanos: "center",
    display: "flex",
  },
}));
